import { EMPTY_LIST } from '../../../../constants/common'
import {
  CONNECTED_REQUESTS_MASS_EDIT_ACTION_OPTION_LABELS,
  CONNECTED_REQUESTS_MASS_EDIT_ACTIONS,
  CONNECTED_REQUESTS_MASS_EDIT_FIELD_OPTION_LABEL_KEYS,
  CONNECTED_REQUESTS_MASS_EDIT_FIELDS,
  CONNECTED_REQUESTS_MASS_EDIT_FORM_FIELD_NAMES,
  CONNECTED_REQUESTS_MASS_EDIT_PARAMETER_FIELD_NAMES,
  CONNECTED_REQUESTS_MASS_EDIT_VISIBILITY_OPTIONS,
} from '../ConnectedRequestsMassEditModal.constants'

function getActionOption(actionValue, t) {
  return {
    label: t(CONNECTED_REQUESTS_MASS_EDIT_ACTION_OPTION_LABELS[actionValue]),
    value: actionValue,
  }
}

function getUsedFieldValues(parameters, index) {
  return parameters
    .map((item, itemIndex) =>
      itemIndex === index
        ? null
        : item[CONNECTED_REQUESTS_MASS_EDIT_PARAMETER_FIELD_NAMES.field]?.value
    )
    .filter(Boolean)
}

function getParameterFieldName(index, parameterFieldName) {
  return `${CONNECTED_REQUESTS_MASS_EDIT_FORM_FIELD_NAMES.parameters}.${index}.${parameterFieldName}`
}

export function getParameterRowKey({ index, parameter }) {
  return (
    parameter?.[CONNECTED_REQUESTS_MASS_EDIT_PARAMETER_FIELD_NAMES.rowId] ||
    index
  )
}

export function getFieldOptions(t) {
  return [
    CONNECTED_REQUESTS_MASS_EDIT_FIELDS.status,
    CONNECTED_REQUESTS_MASS_EDIT_FIELDS.category,
    CONNECTED_REQUESTS_MASS_EDIT_FIELDS.deadline,
    CONNECTED_REQUESTS_MASS_EDIT_FIELDS.managers,
    CONNECTED_REQUESTS_MASS_EDIT_FIELDS.providers,
    CONNECTED_REQUESTS_MASS_EDIT_FIELDS.labels,
    CONNECTED_REQUESTS_MASS_EDIT_FIELDS.visibility,
  ].map(fieldValue => ({
    label: t(CONNECTED_REQUESTS_MASS_EDIT_FIELD_OPTION_LABEL_KEYS[fieldValue]),
    value: fieldValue,
  }))
}

export function getActionOptions(fieldValue, t) {
  switch (fieldValue) {
    case CONNECTED_REQUESTS_MASS_EDIT_FIELDS.status:
    case CONNECTED_REQUESTS_MASS_EDIT_FIELDS.category:
    case CONNECTED_REQUESTS_MASS_EDIT_FIELDS.visibility:
      return [getActionOption(CONNECTED_REQUESTS_MASS_EDIT_ACTIONS.edit, t)]
    case CONNECTED_REQUESTS_MASS_EDIT_FIELDS.deadline:
      return [
        getActionOption(CONNECTED_REQUESTS_MASS_EDIT_ACTIONS.edit, t),
        getActionOption(CONNECTED_REQUESTS_MASS_EDIT_ACTIONS.delete, t),
      ]
    case CONNECTED_REQUESTS_MASS_EDIT_FIELDS.managers:
    case CONNECTED_REQUESTS_MASS_EDIT_FIELDS.providers:
    case CONNECTED_REQUESTS_MASS_EDIT_FIELDS.labels:
      return [
        getActionOption(CONNECTED_REQUESTS_MASS_EDIT_ACTIONS.add, t),
        getActionOption(CONNECTED_REQUESTS_MASS_EDIT_ACTIONS.edit, t),
        getActionOption(CONNECTED_REQUESTS_MASS_EDIT_ACTIONS.findAndRemove, t),
        getActionOption(CONNECTED_REQUESTS_MASS_EDIT_ACTIONS.delete, t),
      ]
    default:
      return EMPTY_LIST
  }
}

export function getParameterFieldNames(index) {
  return {
    actionName: getParameterFieldName(
      index,
      CONNECTED_REQUESTS_MASS_EDIT_PARAMETER_FIELD_NAMES.action
    ),
    commentName: getParameterFieldName(
      index,
      CONNECTED_REQUESTS_MASS_EDIT_PARAMETER_FIELD_NAMES.comment
    ),
    commentTemplateName: getParameterFieldName(
      index,
      CONNECTED_REQUESTS_MASS_EDIT_PARAMETER_FIELD_NAMES.template
    ),
    fieldName: getParameterFieldName(
      index,
      CONNECTED_REQUESTS_MASS_EDIT_PARAMETER_FIELD_NAMES.field
    ),
    isCommentName: getParameterFieldName(
      index,
      CONNECTED_REQUESTS_MASS_EDIT_PARAMETER_FIELD_NAMES.isComment
    ),
    valueName: getParameterFieldName(
      index,
      CONNECTED_REQUESTS_MASS_EDIT_PARAMETER_FIELD_NAMES.value
    ),
  }
}

export function getAvailableFieldOptions({
  allFieldOptions,
  index,
  parameters,
}) {
  const usedFieldValues = getUsedFieldValues(parameters, index)

  return allFieldOptions.filter(
    option => !usedFieldValues.includes(option.value)
  )
}

export function getVisibilityForDwellersOptions(t) {
  return CONNECTED_REQUESTS_MASS_EDIT_VISIBILITY_OPTIONS.map(option => ({
    ...option,
    label: t(option.label),
  }))
}
